import { Source, SourceType, getSources } from '@avnu/avnu-sdk';
import { createAsyncAtom } from '../../lib';

interface AVNUSource {
  name: string;
  type: SourceType;
}

const avnuLiquiditySourcesAtom = createAsyncAtom<AVNUSource[]>(
  async () => {
    try {
      const response = await getSources();

      return response.map((source: Source) => {
        return {
          name: source.name,
          type: source.type,
        };
      });
    } catch (e) {
      console.error('Failed to get AVNU liquidity sources', e);
      return [];
    }
  },
  undefined,
  ['user-refresh'],
);

export default avnuLiquiditySourcesAtom;
